/*
 * File: CustomAddTaskForm.tsx
 * Project: a-a
 * File Created: Wednesday, 19th February 2025 12:30:05 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 22nd September 2025 4:42:41 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useRef, useState } from 'react';
import zeplinColor from '../../../../theme/Color';
import CustomButton from '../../CustomButton/CustomButton';
import {
  Box,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CustomTextField from '../../CustomTextField/CustomTextField';
import { useInput } from '../../../../customHook/useInput';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import CustomDragnDrop from '../../CustomDragnDrop/CustomDragnDrop';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import SubtaskCard from '../../CustomSubtaskCard/CustomSubtaskCard';
import { Dayjs } from 'dayjs';
import { Constants } from '../../../../utilities/constants';
import { LightTooltip } from '../../CustomTooltip/CustomTooltip';
import CustomAutocomplete from '../../CustomAutocomplete/CustomAutocomplete';
import CustomLoader from '../../CustomLoader/CustomLoader';
import styles from './CustomAddTaskForm.module.css';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

const CustomAddTaskForm = ({
  subtask,
  OnClickSubtask,
  handleEmailChange,
  handleEmailBlur,
  email,
  invalidEmail,
  didEmailChange,
  handleTermsChange,
  handleTermsBlur,
  terms,
  invalidTerms,
  didTermsChange,
  handlePayeeChange,
  handlePayeeBlur,
  payee,
  invalidPayee,
  didPayeeChange,
  handleRateChange,
  handleRateBlur,
  rate,
  invalidRate,
  didRateChange,
  handleQTYChange,
  handleQTYBlur,
  qTY,
  invalidQTY,
  didQTYChange,
  handleCommentChange,
  handleCommentBlur,
  comment,
  invalidComment,
  didCommentChange,
  handleLinkChange,
  handleLinkBlur,
  link,
  invalidLink,
  didLinkChange,
  handleSubjectChange,
  handleSubjectBlur,
  subject,
  invalidSubject,
  didSubjectChange,
  error,
  Priority,
  selectedItems,
  handleDeleteItems,
  handleSelection,
  onDrop,
  selectedFiles,
  add,
  deleteFile,
  selectedType,
  subTask,
  date,
  setDate,
  Status,
  Assign,
  edit,
  relatedTo,
  name,
  formLoading,
  setFormLoading,
}: {
  subtask: boolean;
  OnClickSubtask: () => void;
  handleTermsChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleTermsBlur?: () => void;
  terms?: string;
  invalidTerms?: boolean;
  didTermsChange?: boolean;
  handleEmailChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleEmailBlur?: () => void;
  email?: string;
  invalidEmail?: boolean;
  didEmailChange?: boolean;
  handlePayeeChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handlePayeeBlur?: () => void;
  payee?: string;
  invalidPayee?: boolean;
  didPayeeChange?: boolean;
  handleQTYChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleQTYBlur?: () => void;
  qTY?: string;
  invalidQTY?: boolean;
  didQTYChange?: boolean;
  handleRateChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRateBlur?: () => void;
  rate?: string;
  invalidRate?: boolean;
  didRateChange?: boolean;
  handleCommentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCommentBlur: () => void;
  comment: string;
  invalidComment: boolean;
  didCommentChange: boolean;
  handleLinkChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleLinkBlur: () => void;
  link: string;
  invalidLink: boolean;
  didLinkChange: boolean;
  handleSubjectChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubjectBlur: () => void;
  subject: string;
  invalidSubject: boolean;
  didSubjectChange: boolean;
  error: string;
  Priority: string[];
  selectedItems: {
    priority: string;
    status: string;
    related: { Name: string; Id: string }[];
    relatedType: string[];
    assignTo: { Name: string; Id: string }[];
    nameType: string[];
    name: { Name: string; Id: string }[];
    dueDate: string;
    payee: { Name: string; Id: string }[];
    terms: string[];
  };
  handleSelection: (item: any, type: string) => void;
  handleDeleteItems: (item: any, type: string) => void;
  onDrop: (acceptedFile: any) => void;
  selectedFiles: File[];
  add: () => void;
  deleteFile: (index: number) => void;
  selectedType: string;
  subTask?: {
    subject: string;
    comment: string;
    link: string;
  }[];
  setDate: React.Dispatch<React.SetStateAction<Dayjs | null>>;
  date: Dayjs | null;
  Status: string[];
  Assign: { Name: string; Id: string }[];
  edit: boolean;
  relatedTo: {
    account: {
      Name: string;
      Id: string;
    }[];

    deal: {
      Name: string;
      Id: string;
    }[];
  };

  name: {
    lead: {
      Name: string;
      Id: string;
    }[];
    contact: {
      Name: string;
      Id: string;
    }[];
  };
  formLoading: boolean;
  setFormLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));
  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      console.log(event.target.files, Array.from(event.target.files));
      onDrop(Array.from(event.target.files));
    }
  };
  const disable =
    !subject || !selectedItems.assignTo || !selectedItems.priority || !selectedItems.status;
  const [AssignOptions, setAssignOptions] = useState(
    Array.isArray(Assign) ? [...Assign] : [Assign],
  );
  const [relatedOptions, setRelatedOptions] = useState(
    relatedTo[
      (selectedItems.relatedType[0].toLocaleLowerCase() || 'account') as keyof typeof relatedTo
    ]?.slice(0, 5),
  );
  const [payeeOptions, setPayeeOptions] = useState(
    relatedTo['account' as keyof typeof relatedTo]?.slice(0, 5),
  );
  const [nameOptions, setNameOptions] = useState(
    name[(selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name]?.slice(
      0,
      5,
    ),
  );
  const handleAssignToFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = AssignOptions?.filter((e) =>
        e.Name.toLocaleLowerCase()?.includes(value.toLocaleLowerCase()),
      );
      setAssignOptions(filter);
    } else {
      setAssignOptions([...Assign]);
    }
  };
  const handleRelatedFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = relatedTo[
        (selectedItems.relatedType[0].toLocaleLowerCase() || 'account') as keyof typeof relatedTo
      ]?.filter((e) => e.Name.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
      setRelatedOptions(filter);
    } else {
      setRelatedOptions(
        relatedTo[
          (selectedItems.relatedType[0].toLocaleLowerCase() || 'account') as keyof typeof relatedTo
        ]?.slice(0, 5),
      );
    }
  };
  const handleNameFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = name[
        (selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name
      ]?.filter((e) => e.Name.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
      setNameOptions(filter);
    } else {
      setNameOptions(
        name[
          (selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name
        ]?.slice(0, 5),
      );
    }
  };
  const handlePayeeFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = relatedTo['account' as keyof typeof relatedTo]
        ?.slice(0, 5)
        ?.filter((e) => e.Name.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
      setPayeeOptions(filter);
    } else {
      setPayeeOptions(relatedTo['account' as keyof typeof relatedTo]?.slice(0, 5));
    }
  };
  const [initial, setInitial] = useState(
    edit ? { related: true, name: true } : { related: false, name: false },
  );
  useEffect(() => {
    if (selectedItems?.relatedType[0] !== 'None') {
      setRelatedOptions(
        relatedTo[
          (selectedItems.relatedType[0].toLocaleLowerCase() || 'account') as keyof typeof relatedTo
        ]?.slice(0, 5),
      );
    } else {
      setRelatedOptions([]);
    }
    !initial?.related && handleSelection({ Name: '', Id: '' }, 'related');
    initial?.related && setInitial((prev) => ({ ...prev, related: false }));
  }, [selectedItems?.relatedType]);
  useEffect(() => {
    if (selectedItems?.nameType[0] !== 'None') {
      setNameOptions(
        name[
          (selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name
        ]?.slice(0, 5),
      );
    } else {
      setNameOptions([]);
    }
    if (selectedItems?.nameType[0].toLocaleLowerCase() === 'lead') {
      handleSelection({ Name: '', Id: '' }, 'related');
      handleSelection([''], 'relatedType');
    }
    !initial?.name && handleSelection({ Name: '', Id: '' }, 'name');
    initial?.name && setInitial((prev) => ({ ...prev, name: false }));
  }, [selectedItems?.nameType]);

  let totalAssignLength = Assign.length;
  let totalRelatedLength =
    relatedTo[
      (selectedItems.relatedType[0].toLocaleLowerCase() || 'account') as keyof typeof relatedTo
    ]?.length;
  let totalPayeeLength = relatedTo['account' as keyof typeof relatedTo]?.length;
  let totalNameLength =
    name[(selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name]?.length;
  let currentAssignLength = useRef(0);
  let currentRelatedLength = useRef(0);
  let currentPayeeLength = useRef(0);
  let currentNameLength = useRef(0);
  const handleAssignToScroll = () => {
    setAssignOptions([...Assign]);
  };
  const handleRelatedScroll = () => {
    setRelatedOptions([
      ...relatedTo[
        (selectedItems.relatedType[0].toLocaleLowerCase() || 'account') as keyof typeof relatedTo
      ]?.slice(0, currentRelatedLength.current + 5),
    ]);
    currentRelatedLength.current += 5;
  };
  const handlePayeeScroll = () => {
    setRelatedOptions([
      ...relatedTo['account' as keyof typeof relatedTo]?.slice(0, currentPayeeLength.current + 5),
    ]);
    currentPayeeLength.current += 5;
  };
  const handleNameScroll = () => {
    setNameOptions([
      ...name[
        (selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name
      ]?.slice(0, currentNameLength.current + 5),
    ]);
    currentNameLength.current += 5;
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          //   marginTop: '24px',
          padding: '24px 24px 24px 24px',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          //   height: '100vh',
          //   paddingBottom: '34px',
          //   overflowY: 'auto',
        }}
      >
        <CustomTextField
          style={{ width: '100%' }}
          onBlur={handleSubjectBlur}
          onChange={handleSubjectChange}
          name='Subject'
          text={subject}
          form={true}
          error={
            error ? error : invalidSubject && didSubjectChange ? 'Please enter valid Subject' : ''
          }
          label={'Subject'}
          type='text'
          tabindex={1}
          required
        />
        <FormControl sx={{ width: '100%' }}>
          {/* <InputLabel
            id='demo-multiple-name-label'
            sx={{
              '&.Mui-focused': { color: zeplinColor.Neutral9 },
            }}
          >
            Assign to<span style={{ color: zeplinColor.Error }}>*</span>
          </InputLabel>
          <Select
            labelId='demo-multiple-name-label'
            id='demo-multiple-name'
            // multiple
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
            required={true}
            value={selectedItems.assignTo}
            onChange={(e) => handleSelection(e, 'assignTo')}
            input={
              <OutlinedInput
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderWidth: '1px',
                    color: zeplinColor.Neutral9,
                    borderColor: zeplinColor.Neutral9,
                  },
                }}
                label='Assign to'
              />
            }
            renderValue={(selected) => (
              <Chip
                label={selected}
                onDelete={(e) => {
                  handleDeleteItems(e, 'assignTo');
                }}
                deleteIcon={
                  <img
                    width={'18px'}
                    height={'18px'}
                    src={'/assets/x-mark.svg'}
                    alt='delete-icon'
                    onClick={(e) => {
                      handleDeleteItems(e, 'assignTo');
                    }}
                    aria-hidden='false'
                    // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
                  />
                }
              />
            )}
            MenuProps={MenuProps}
            IconComponent={KeyboardArrowDown}
          >
            {Priority.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox
                  checked={selectedItems.priority.indexOf(name) > -1}
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                  }}
                />
                {name}
              </MenuItem>
            ))}
          </Select> */}
          <CustomAutocomplete
            required={true}
            options={AssignOptions || []}
            getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
            label={'Assign To'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              handleSelection(value, 'assignTo');
            }}
            value={selectedItems?.assignTo[0]}
            handleFilter={handleAssignToFilter}
            placeholder='Search people'
            currentLength={AssignOptions?.length}
            totalLength={totalAssignLength}
            next={handleAssignToScroll}
            multiple={false}
          />
        </FormControl>
        {/* <FormControl sx={{ width: '100%' }}>
          <InputLabel
            id='demo-multiple-name-label'
            sx={{
              '&.Mui-focused': { color: zeplinColor.Neutral9 },
            }}
          >
            Related to
          </InputLabel>
          <Select
            labelId='demo-multiple-name-label'
            id='demo-multiple-name'
            multiple
            value={selectedItems.priority}
            onChange={(e) => handleSelection(e, 'priority')}
            input={
              <OutlinedInput
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderWidth: '1px',
                    color: zeplinColor.Neutral9,
                    borderColor: zeplinColor.Neutral9,
                  },
                }}
                label='Related to'
              />
            }
            renderValue={(selected) => (selected as string[]).join(', ')}
            MenuProps={MenuProps}
            IconComponent={KeyboardArrowDown}
          >
            {Priority.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox
                  checked={selectedItems.priority.indexOf(name) > -1}
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                  }}
                />
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
              }}
            >
              Name type
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              // multiple
              value={
                typeof selectedItems.nameType == 'string'
                  ? selectedItems.nameType
                  : selectedItems.nameType[0]
              }
              onChange={(e) => handleSelection(e, 'nameType')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Name type'
                />
              }
              renderValue={(selected) => {
                // console.log(selected);
                return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
              }}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {[...Object.keys(name), 'None'].map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={selectedItems.nameType.indexOf(name) > -1} // Check if this radio should be selected
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />

                  {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ width: '100%' }}>
            {/* <InputLabel
              id='demo-multiple-name-label'
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
              }}
            >
              Name
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              // multiple
              value={selectedItems.name}
              onChange={(e) => handleSelection(e, 'name')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Name'
                />
              }
              renderValue={(selected) => selected}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {Priority.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    checked={selectedItems.priority.indexOf(name) > -1}
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {name}
                </MenuItem>
              ))}
            </Select> */}

            <CustomAutocomplete
              options={nameOptions || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Name'}
              handleDeleteItems={handleDeleteItems}
              selectedItems={selectedItems}
              handleSelection={(value) => {
                handleSelection(value, 'name');
              }}
              multiple={false}
              value={selectedItems?.name[0]}
              handleFilter={handleNameFilter}
              placeholder='Search name'
              currentLength={nameOptions?.length}
              totalLength={totalNameLength}
              next={handleNameScroll}
              disabled={selectedItems?.nameType[0] ? false : true}
            />
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
              }}
            >
              Related type
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              disabled={selectedItems?.nameType[0] === 'lead'}
              // multiple
              value={
                typeof selectedItems.relatedType == 'string'
                  ? selectedItems.relatedType
                  : selectedItems.relatedType[0]
              }
              onChange={(e) => handleSelection(e, 'relatedType')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Related type'
                />
              }
              renderValue={(selected) => {
                // console.log(selected);
                return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
              }}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {[...Object.keys(relatedTo), 'None'].map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={selectedItems.relatedType.indexOf(name) > -1} // Check if this radio should be selected
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ width: '100%' }}>
            {/* <InputLabel
              id='demo-multiple-name-label'
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
              }}
            >
              Related to
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              // multiple
              value={selectedItems.related}
              onChange={(e) => handleSelection(e, 'related')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Related to'
                />
              }
              renderValue={(selected) => selected}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {relatedTo.account.slice(0, 10).map((name) => (
                <MenuItem key={name.Id} value={name.Id}>
                  <Radio
                    checked={selectedItems.status.indexOf(name.Id) > -1} // Check if this radio should be selected
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {name.Name}
                </MenuItem>
              ))}
            </Select> */}
            <CustomAutocomplete
              options={relatedOptions || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Related To'}
              disabled={selectedItems?.nameType[0] === 'lead' || !selectedItems?.relatedType[0]}
              handleDeleteItems={handleDeleteItems}
              selectedItems={selectedItems}
              handleSelection={(value) => {
                handleSelection(value, 'related');
              }}
              multiple={false}
              value={selectedItems.related[0]}
              handleFilter={handleRelatedFilter}
              placeholder={`Search ${selectedItems.relatedType[0] ?? 'account'}`}
              currentLength={relatedOptions?.length || 0}
              totalLength={totalRelatedLength}
              next={handleRelatedScroll}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <CustomDatePicker value={date} setValue={setDate} />
          {selectedType === 'Payment Task' && (
            // <CustomTextField
            //   style={{ width: '100%' }}
            //   onBlur={() => {
            //     handlePayeeBlur && handlePayeeBlur();
            //   }}
            //   onChange={(e) => {
            //     handlePayeeChange && handlePayeeChange(e);
            //   }}
            //   name={'Payee'}
            //   text={payee ? payee : ''}
            //   error={
            //     error ? error : invalidPayee && didPayeeChange ? 'Please enter valid Payee' : ''
            //   }
            //   label={'Payee'}
            //   type='text'
            //   tabindex={1}
            //   // required
            // />
            <Box sx={{ width: '100%' }}>
              <CustomAutocomplete
                options={payeeOptions}
                getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
                label={'Payee'}
                disabled={false}
                handleDeleteItems={handleDeleteItems}
                selectedItems={selectedItems}
                handleSelection={(value) => {
                  handleSelection(value, 'payee');
                }}
                multiple={false}
                value={selectedItems.payee[0]}
                handleFilter={handlePayeeFilter}
                placeholder={`Search payee`}
                currentLength={payeeOptions?.length}
                totalLength={totalPayeeLength}
                next={handlePayeeScroll}
              />
            </Box>
          )}
        </Box>
        {selectedType === 'Payment Task' && (
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleQTYBlur && handleQTYBlur();
              }}
              form={true}
              onChange={(e) => {
                handleQTYChange && handleQTYChange(e);
              }}
              name={'QTY'}
              text={qTY ? qTY : ''}
              error={error ? error : invalidQTY && didQTYChange ? 'Please enter valid QTY' : ''}
              label={'QTY'}
              type='number'
              tabindex={1}
              // required
            />

            <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleRateBlur && handleRateBlur();
              }}
              form={true}
              onChange={(e) => {
                handleRateChange && handleRateChange(e);
              }}
              name={'Rate'}
              text={rate ? `${rate}` : ''}
              error={error ? error : invalidRate && didRateChange ? 'Please enter valid rate' : ''}
              label={'Rate'}
              type='number'
              tabindex={1}
              // required
            />
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
              }}
            >
              Status<span style={{ color: zeplinColor.Error }}>*</span>
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              // multiple
              size={isXs ? 'small' : 'medium'}
              required={true}
              value={selectedItems.status}
              onChange={(e) => handleSelection(e, 'status')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Status'
                />
              }
              renderValue={
                (selected) => (
                  // (selected as string[]).map((val) => (
                  <Chip
                    label={<Typography variant='label1'>{selected}</Typography>}
                    sx={{
                      bgcolor:
                        Constants.StatusTask[
                          (selected || 'To Do') as 'To Do' | 'In Progress' | 'Done'
                        ],
                      color: zeplinColor.Neutral1,
                      // width: '39px',
                      '&.MuiChip-root': {
                        height: '29px',
                        padding: '4px 14px',
                        borderRadius: '50px',
                      },
                      '& .MuiChip-label': {
                        padding: 0,
                      },
                    }}
                  />
                )
                // ))
              }
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {Status.map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={selectedItems.status.indexOf(name) > -1} // Check if this radio should be selected
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
              }}
            >
              Priority<span style={{ color: zeplinColor.Error }}>*</span>
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              // multiple
              size={isXs ? 'small' : 'medium'}
              required={true}
              value={selectedItems.priority}
              onChange={(e) => handleSelection(e, 'priority')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Priority'
                />
              }
              renderValue={
                (selected) => (
                  // (selected as string[]).map((val) => (
                  <Chip
                    label={<Typography variant='label1'>{selected}</Typography>}
                    sx={{
                      bgcolor:
                        Constants.PriorityTask[(selected || 'Medium') as 'Normal' | 'Low' | 'High'],
                      color: zeplinColor.Neutral1,
                      // width: '39px',
                      '&.MuiChip-root': {
                        height: '29px',
                        padding: '4px 14px',
                        borderRadius: '50px',
                      },
                      '& .MuiChip-label': {
                        padding: 0,
                      },
                    }}
                  />
                )
                // ))
              }
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {Priority.map((name) => (
                <MenuItem key={name} value={name}>
                  {/* <Checkbox
                    checked={selectedItems.priority.indexOf(name) > -1}
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  /> */}
                  <Radio
                    checked={selectedItems.priority.indexOf(name) > -1} // Check if this radio should be selected
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {selectedType === 'Payment Task' && (
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            {/* <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleTermsBlur && handleTermsBlur();
              }}
              onChange={(e) => {
                handleTermsChange && handleTermsChange(e);
              }}
              name={'Terms'}
              text={terms ? terms : ''}
              error={
                error ? error : invalidTerms && didTermsChange ? 'Please enter valid Terms' : ''
              }
              label={'Terms'}
              type='text'
              tabindex={1}
              // required
            /> */}
            <FormControl sx={{ width: '100%' }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Terms
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                // disabled={selectedItems?.nameType[0] === 'lead'}
                // multiple
                value={selectedItems?.terms}
                onChange={(e) => handleSelection(e, 'terms')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Related type'
                  />
                }
                renderValue={(selected) =>
                  `${selected[0].slice(0, 1).toLocaleUpperCase()}${selected[0].slice(1)}`
                }
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {['Net 30', 'Net 60', 'Net 90', 'None'].map((name) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.relatedType.indexOf(name) > -1} // Check if this radio should be selected
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />
                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleEmailBlur && handleEmailBlur();
              }}
              form={true}
              onChange={(e) => {
                handleEmailChange && handleEmailChange(e);
              }}
              name={'Email'}
              text={email ? email : ''}
              error={
                error ? error : invalidEmail && didEmailChange ? 'Please enter valid email' : ''
              }
              label={'Email'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
        )}
        <CustomTextField
          style={{ width: '100%' }}
          onBlur={handleCommentBlur}
          onChange={handleCommentChange}
          name='Comments'
          text={comment}
          form={true}
          error={
            error ? error : invalidComment && didCommentChange ? 'Please enter valid Comment' : ''
          }
          label={'Comments'}
          type='text'
          tabindex={1}
          multiline
          // required
        />
        <CustomTextField
          style={{ width: '100%' }}
          form={true}
          onBlur={handleLinkBlur}
          onChange={handleLinkChange}
          name='Link'
          text={link}
          error={error ? error : invalidLink && didLinkChange ? 'Please enter valid Link' : ''}
          label={'Link'}
          type='text'
          tabindex={1}
          // required
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
              <img
                className={styles.icon}
                src={'/assets/attachment.svg'}
                alt='logo'
                style={{ objectFit: 'fill' }}
              />
              <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                Attachment
              </Typography>
            </Box>

            {selectedFiles?.length ? (
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  width: '100%',
                  alignItems: 'center',
                  flex: 1,
                  justifyContent: 'flex-end',
                  cursor: 'pointer',
                }}
                // onClick={OnClickSubtask}
                onClick={openInput}
              >
                <input
                  type='file'
                  id='attachment'
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />
                <img
                  width={'24px'}
                  height={'24px'}
                  src={'/assets/upload-blue.svg'}
                  alt='logo'
                  style={{ objectFit: 'fill' }}
                />
                <Typography variant='buttonMedium' color={zeplinColor.Brand1}>
                  Select File
                </Typography>
              </Box>
            ) : (
              ''
            )}
          </Box>
          {!selectedFiles?.length ? (
            <CustomDragnDrop onDrop={onDrop} />
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {selectedFiles.map((file, index) => (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px',
                  }}
                >
                  <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <img
                      width={'40px'}
                      height={'40px'}
                      src={
                        file?.name
                          ? `/assets/${file?.name
                              ?.split('.')
                              [file?.name?.split('.')?.length - 1].toLocaleLowerCase()}.svg`
                          : `/assets/${file
                              ?.toString()
                              .split('.')
                              [file?.toString()?.split('.')?.length - 1].toLocaleLowerCase()}.svg`
                      }
                      alt='file-type'
                      style={{ objectFit: 'fill' }}
                    />
                    <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                      <LightTooltip
                        title={
                          <Typography variant='body3' color={zeplinColor.Neutral1}>
                            {file.name}
                          </Typography>
                        }
                        placement='bottom-end'
                        style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                      >
                        <Typography variant='body2'>
                          {file?.name ? file?.name?.slice(0, 40) : file?.toString()?.slice(0, 40)}
                          {file?.name
                            ? file?.name?.length > 40 && '...'
                            : file?.toString()?.length > 40 && '...'}
                        </Typography>
                      </LightTooltip>
                      <Typography variant='label1'>{file.size / 10000}MB</Typography>
                    </Box>
                  </Box>
                  <img
                    width={'24px'}
                    height={'24px'}
                    src={'/assets/delete-blue.svg'}
                    alt='logo'
                    style={{ objectFit: 'fill', cursor: 'pointer' }}
                    onClick={() => deleteFile(index)}
                  />
                </Box>
              ))}
            </Box>
          )}
        </Box>
        {/* {!subtask && selectedType === 'A&A Management Task' ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{ display: 'flex', gap: '8px', width: '100%', alignItems: 'center', flex: 1 }}
              >
                <img
                  width={'24px'}
                  height={'24px'}
                  src={'/assets/subtask.svg'}
                  alt='logo'
                  style={{ objectFit: 'fill' }}
                />
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  Subtask
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  width: '100%',
                  alignItems: 'center',
                  flex: 1,
                  justifyContent: 'flex-end',
                  cursor: 'pointer',
                }}
                onClick={OnClickSubtask}
              >
                <img
                  width={'24px'}
                  height={'24px'}
                  src={'/assets/add-blue.svg'}
                  alt='logo'
                  style={{ objectFit: 'fill' }}
                />
                <Typography variant='buttonMedium' color={zeplinColor.Brand1}>
                  Add Subtask
                </Typography>
              </Box>
            </Box>
            {subTask?.length
              ? subTask.map((val) => <SubtaskCard data={val} loading={false} />)
              : ''}
          </Box>
        ) : (
          ''
        )} */}
      </Box>
      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          bottom: '0px',
          margin: 'auto',
          zIndex: '100',
          padding: '24px',
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <CustomButton
          disabled={disable || formLoading}
          onClick={add}
          variant='contained'
          color={disable ? 'customDisable' : 'primary'}
          style={{
            borderRadius: '14px',
            height: 56,
            width: '100%',
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
          }}
          textStyle={{ color: disable ? zeplinColor.Neutral8 : zeplinColor.Neutral1 }}
          text={
            subtask
              ? !formLoading
                ? 'Add Subtask'
                : 'Adding Subtask'
              : edit
              ? !formLoading
                ? 'Save'
                : 'Saving'
              : !formLoading
              ? 'Create Task'
              : 'Creating Task'
          }
          // tabindex={4}
        />
      </Box>
      {/* {formLoading ? (
        <CustomLoader
          open={formLoading}
          handleCloseModal={() => {
            setFormLoading(false);
          }}
        />
      ) : (
        ''
      )} */}
    </>
  );
};

export default CustomAddTaskForm;
